import React, { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import { Button, Svg } from 'ui'
import { navigate } from 'gatsby'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'
import ButtonArrow from 'images/button-arrow-right.svg'

export default function CTAButtons(): ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        maxWidth: '102.2rem',
        justifyContent: 'center',
        py: '4rem',
        borderTop: '1px solid',
        borderTopColor: 'blueYonder20',
        borderBottom: '1px solid',
        borderBottomColor: 'blueYonder20',
      }}
    >
      <Flex
        sx={{
          gap: ['0.8rem', '1.6rem'],
          alignContent: ['center', 'flex-start'],
          flexDirection: 'row',
          flexWrap: ['wrap', 'nowrap'],
          justifyContent: ['center', 'flex-start'],
        }}
      >
        <Button
          data-testid="take-it-now-button"
          sx={{
            display: 'inline-flex',
            justifyContent: 'center',
            flexShrink: 0,
            flex: ['1', 'none'],
            width: 'fit-content',
            minWidth: ['12.4rem', '18rem'],
            px: ['1.2rem', '2rem'],
            height: ['4rem', '4.7rem'],
            whiteSpace: 'nowrap',
            alignItems: 'center',
          }}
          variant="gradientButton"
          ariaLabel="Start Free Trial"
          name="Start Free Trial"
          onClick={() => navigate('/onboard')}
        >
          <TextWithBreakpointVariant variant={['size16Weight600Line138', 'size17Weight600Line138']}>
            Start Free Trial
          </TextWithBreakpointVariant>
          <Svg
            svg={ButtonArrow}
            sx={{
              ml: '0.6rem',
            }}
            descriptiveText="Right arrow icon for Start Free Trial button"
          />
        </Button>
        <Button
          ariaLabel="Book a Demo"
          name="Book a Demo"
          data-testid="book-demo-button"
          sx={{
            display: 'inline-flex',
            flexShrink: 0,
            width: ['12.9rem', 'fit-content'],
            px: ['0.8rem', '2rem'],
            height: ['4rem', '4.7rem'],
            minWidth: ['12.9rem', '15rem'],
            whiteSpace: 'nowrap',
            '@media (max-width: 324px)': {
              width: '100%',
            },
          }}
          variant="roundedSecondary"
          onClick={() => navigate('/demo')}
        >
          <TextWithBreakpointVariant variant={['size16Weight600Line138', 'size17Weight600Line138']}>
            Book a Demo
          </TextWithBreakpointVariant>
        </Button>
      </Flex>
    </Flex>
  )
}
